/**
 * Shared column-grid template for the Issues List table. The header row
 * (`IssuesListHeaderRow`) and the data rows (`IssuesListRow`) MUST use this
 * exact template or their cells will misalign — keep it in one place.
 *
 * Columns are responsive to the LIST CARD's own width (`@container/list`,
 * declared on the scroll region in IssuesListBody — container queries, never
 * viewport breakpoints inside the panel):
 *   base           Issue · Age · action
 *   ≥560px/list    + Status chip        (Open / In review / Closed)
 *   ≥760px/list    + Location           (site · mandal)
 * Cells/headers for the optional columns carry the matching `hidden
 * @[…]/list:*` visibility classes so grid auto-placement stays aligned with
 * the active template at every width.
 */
// Original (with Severity column + wide action col):
// export const ISSUE_TABLE_COLS =
//   'grid grid-cols-[minmax(0,2.4fr)_minmax(0,1.5fr)_minmax(0,1.6fr)_64px_84px_104px_64px] items-center gap-3'
export const ISSUE_TABLE_COLS =
  'grid grid-cols-[minmax(0,2.4fr)_64px_44px] @[560px]/list:grid-cols-[minmax(0,2.4fr)_88px_64px_44px] @[760px]/list:grid-cols-[minmax(0,2.4fr)_minmax(0,1.6fr)_88px_64px_44px] items-center gap-3'

/** Visibility classes for the optional columns — shared by header + row cells. */
export const COL_STATUS = 'hidden @[560px]/list:block'
export const COL_LOCATION = 'hidden @[760px]/list:block'
